package com.narbase.letsgo.web.views.analytics

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.web.dto.analytics.AnalyticsConfigDto
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.analytics.GetAnalyticsSettingsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.analytics.UpsertAnalyticsSettingsEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class AnalyticsManagementViewModel {

    val settingsUiState = Observable<BasicUiState>()
    val upsertUiState = Observable<BasicUiState>()

    var settings: AnalyticsConfigDto? = null
        private set

    fun getSettings() {
        basicNetworkCall(settingsUiState) {
            settings = GetAnalyticsSettingsEndpoint.remoteProcess(GetAnalyticsSettingsEndpoint.Request()).data.settings
        }
    }

    fun saveSettings(edited: AnalyticsConfigDto) {
        basicNetworkCall(upsertUiState) {
            settings = UpsertAnalyticsSettingsEndpoint
                .remoteProcess(UpsertAnalyticsSettingsEndpoint.Request(edited)).data.settings
        }
    }
}
